module.exports = __webpack_public_path__ + "static/premium-classic-41594f375f6ad11eb46c3f1a08f890dc.png";